import 'date-fns'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import DateFnsUtils from '@date-io/date-fns'
import ptLocale from "date-fns/locale/pt-BR";
import { useFormContext, Controller } from 'react-hook-form'
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers'
import { makeStyles } from '@material-ui/core/styles'
import inputStyle from './input-style'

const InputDateTime = ({ defaultValue, name, variant, disableMargin, ...rest }) => {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext()
  const classes = useStyles()

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptLocale}>
      <div
        className={clsx({
          [classes.customTextField]: !disableMargin,
        })}
      ></div>
      <Controller
        render={({ field }) => (
          <KeyboardDateTimePicker
            {...field}
            {...rest}
            name={name}
            value={field.value || null}
            fullWidth
            autoOk
            inputVariant={variant}
            InputLabelProps={ { style: { position: 'relative', marginBottom: '5px', transform: 'translate(0, 0) scale(1)' }, shrink: false }}
            variant='inline'
            format='dd/MM/yyyy HH:mm'
            invalidDateMessage='Formato de data inválido'
            maxDateMessage='A data não deve ser posterior à data máxima'
            minDateMessage='A data não deve ser anterior à data mínima'
            ampm={false}
            
          />
        )}
        name={name}
        control={control}
        defaultValue={defaultValue}
        disabled={isSubmitting}
      />
    </MuiPickersUtilsProvider>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '10px 0px',
  },
  customTextField: inputStyle(theme)
}))

InputDateTime.propTypes = {
  defaultValue: PropTypes.string,
  disableMargin: PropTypes.bool,
  name: PropTypes.string.isRequired,
  variant: PropTypes.string,
}

InputDateTime.defaultProps = {
  defaultValue: null,
  disableMargin: false,
  variant: 'outlined',
}

export default InputDateTime
